const RETRYABLE_STATUSES = new Set([502, 503, 504]);
const RETRYABLE_ERROR_CODES = new Set([
    'ECONNRESET',
    'ECONNREFUSED',
    'ETIMEDOUT',
    'ENOTFOUND',
]);
const DEFAULT_RETRIES = 2;
const DEFAULT_DELAY_MS = 300;

export async function fetchWithRetry(
    input: RequestInfo | URL,
    init?: RequestInit,
    retries = DEFAULT_RETRIES,
    delayMs = DEFAULT_DELAY_MS
): Promise<Response> {
    let lastResponse: Response | undefined;
    let lastError: unknown;

    for (let attempt = 0; attempt <= retries; attempt++) {
        if (attempt > 0) {
            await new Promise((resolve) =>
                setTimeout(resolve, delayMs * attempt)
            );
        }

        try {
            const response = await fetch(input, init);

            if (!RETRYABLE_STATUSES.has(response.status)) {
                return response;
            }

            lastResponse = response;
            lastError = undefined;
        } catch (error) {
            const code = (error as any)?.code ?? (error as any)?.cause?.code;
            if (RETRYABLE_ERROR_CODES.has(code)) {
                lastError = error;
            } else {
                throw error;
            }
        }
    }

    if (lastError !== undefined) {
        throw lastError;
    }

    return lastResponse!;
}
